import {useCallback} from 'react';
import {useHttpsCallableFunction} from './useHttpsCallableFunction';
import {UserPrototype} from '#common/users/types';

export const OnLoginFunctionName = 'onLogin';

export function useOnLogin(): (user: UserPrototype) => Promise<void> {
  const onLoginFunction = useHttpsCallableFunction<UserPrototype, void>(OnLoginFunctionName);
  return useCallback(
    async (user: UserPrototype) => {
      await onLoginFunction(user);
    },
    [onLoginFunction],
  );
}
